export default "__VITE_ASSET__kuCBDM$I__"